export default __webpack_public_path__ + "static/media/Icare.afbac160.svg";